// this reducer contains all the basic app info
// the most important being the playtest state

import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  badgesEarned: {},
  badgesNext: {},
};

const badgesInfoSlice = createSlice({
  name: 'badges',
  initialState,
  reducers: {
    // this is the function that sets playtest state from the firebase state
    // this is stored here: https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/versionInfo
    updateBadgesData(state, {payload}) {
      console.log('updateBadgesData', payload);
      return {
        ...state,
        badgesEarned: payload.badgesEarned,
        badgesNext: payload.badgesNext,
      };
    },
  },
});

export const {updateBadgesData} = badgesInfoSlice.actions;

export default badgesInfoSlice.reducer;
